import {useContext} from 'react';
import {EventBusContext} from '../providers/EventBus';

export const useEventBus = () => {
  const {bus} = useContext(EventBusContext);
  return bus;
};
